import { useState } from 'react';
import { allLinks } from './data';

import { Communicate, Run, Manage, Build, Others, Pay } from './views/';
import { Fade } from 'react-awesome-reveal';

function App() {
  const [active, setActive] = useState(false);
  const [range, setRange] = useState(0);
  const [visible, setVisible] = useState('communicate');

  return (
    <div className="container mx-auto md:block">
      <h3 className="text-center text-3xl font-bold">Spur Stack</h3>
      <p className="text-center text-gray-500">
        Starting a new business? Get a recommended starter pack of the tools you
        need
      </p>

      <div className="container mx-auto">
        <div className="max-w-[1200px] mx-auto my-10 md:block md:px-0 px-5">
          <div className="mt-[40px] md:flex gap-[40px]">
            <div class="w-full md:w-[25%]">
              <div>
                <label class="block mb-2 text-sm font-medium text-gray-900">
                  Industry
                </label>
                <select class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-600 focus:border-purple-600 block w-full p-2.5 ">
                  <option>Restaurants</option>
                  <option>Fashion</option>
                  <option>Tech</option>
                </select>
              </div>

              <div class="my-6">
                <label class="block mb-2 text-sm font-medium text-gray-900">
                  Number of Employees
                </label>
                <select class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-600 focus:border-purple-600 block w-full p-2.5 ">
                  <option>Sole Proprietor</option>
                  <option>2-10 Employees</option>
                  <option>10-50 Employees</option>
                  <option>50+ Employees</option>
                </select>
              </div>

              <div>
                <label
                  for="savviness"
                  class="flex justify-between items-center mb-2 text-sm font-medium"
                >
                  <span>Tech Savviness</span>
                  <span>{range}</span>
                </label>
                <input
                  id="savviness"
                  type="range"
                  min={0}
                  step={10}
                  max={100}
                  value={range}
                  onChange={(e) => setRange(e.target.value)}
                  class="w-full h-2 bg-gray-200 rounded-lg focus:ring-purple-600 focus:border-purple-600 focus:outline-purple-600 "
                />
              </div>

              <button
                class="bg-[#974d9b] text-white px-5 rounded-md mt-4 py-2"
                onClick={() => {
                  setActive(true);
                }}
              >
                Submit
              </button>
            </div>

            <div class="w-full md:w-[75%]">
              <div className="">
                {active !== false && (
                  <>
                    <div className="md:flex gap-10 hidden">
                      <div className="w-3/12 p-3 mt-[80px]">
                        {allLinks.slice(0, 3).map(({ id, title, tag }) => (
                          <div
                            key={id}
                            className={`my-3 p-2 cursor-pointer border-r-2 ${
                              visible === tag
                                ? 'border-[#974D9B] text-[#100610] font-bold'
                                : 'border-[#EDD2EE] text-gray-400'
                            }`}
                            onClick={() => setVisible(tag)}
                          >
                            {title}
                          </div>
                        ))}
                      </div>
                      <div className="w-6/12">
                        <div className="h-[400px] w-full rounded-md bg-[#f9f9f9] shadow-md mx-auto text-center p-3">
                          <Fade className="mt-[90px]">
                            {visible === 'communicate' && <Communicate />}
                            {visible === 'run' && <Run />}
                            {visible === 'manage' && <Manage />}
                            {visible === 'pay' && <Pay />}
                            {visible === 'build' && <Build />}
                            {visible === 'others' && <Others />}
                          </Fade>
                        </div>
                      </div>
                      <div className="w-3/12  p-3 mt-[80px]">
                        {allLinks.slice(-3).map(({ id, title, tag }) => (
                          <div
                            key={id}
                            className={`my-3 p-2 cursor-pointer border-l-2 ${
                              visible === tag
                                ? 'border-[#974D9B] text-[#100610] font-bold'
                                : 'border-[#EDD2EE] text-gray-400'
                            }`}
                            onClick={() => setVisible(tag)}
                          >
                            {title}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="md:hidden block mt-5">
                      <div className="flex">
                        <div className="w-3/12">
                          {allLinks.map(({ id, title, tag }) => (
                            <div
                              key={id}
                              className={`my-3 py-2 pr-2 cursor-pointer border-r-2 text-xs ${
                                visible === tag
                                  ? 'border-[#974D9B] text-[#100610] font-bold'
                                  : 'border-[#EDD2EE] text-gray-400'
                              }`}
                              onClick={() => setVisible(tag)}
                            >
                              {title}
                            </div>
                          ))}
                        </div>
                        <div className="w-9/12">
                          <div className="h-[50vh] w-full rounded-md bg-[#f9f9f9] shadow-md mx-auto text-center p-3">
                            <Fade className="mt-[90px]">
                              {visible === 'communicate' && <Communicate />}
                              {visible === 'run' && <Run />}
                              {visible === 'manage' && <Manage />}
                              {visible === 'pay' && <Pay />}
                              {visible === 'build' && <Build />}
                              {visible === 'others' && <Others />}
                            </Fade>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
